export const shakespeareVocabPool = [
    {
      archaic: "thou",
      modern: "you",
      distractors: ["they", "your", "the"]
    },
    {
      archaic: "thy",
      modern: "your",
      distractors: ["you", "they", "the"]
    },
    {
      archaic: "art",
      modern: "are",
      distractors: ["is", "was", "be"]
    }
  ];
  